/* eslint-disable no-alert */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../components/Box';
import { Button } from '../../../../../components/Buttons';
import { Card } from '../../../../../components/Card';
import { selectUserId, selectWork, selectWorks } from '../../../../Api/selectors';
import { VehicleBpmCard } from '../../../components/CardBPM';
import { VehicleCardCounters } from '../../../components/CardCounters';
import { VehicleDataCard } from '../../../components/CardData';
import { VehicleDocumentsCard } from '../../../components/CardDocuments';
import { VehicleFinancePurchaseCard } from '../../../components/CardFinancePurchase';
import { VehicleFinanceSalesCard } from '../../../components/CardFinanceSales';
import { VehicleInfoCard } from '../../../components/CardInfo';
import { VehicleLabelCard } from '../../../components/CardLabel';
import { VehicleDataConsumptionCard } from '../../../components/ConsumptionEnviromentData';
import { VehicleRDWandHistoryDataCard } from '../../../components/RDWandHistoryCard';
import { Slider } from '../../../components/Slider';
import { VehicleLocationCard } from '../../../components/VehicleLocationCard';
import { VehicleHooicardproducts } from '../../../components/cardHooicardproducts';
import { VehicleHooicardtakeout } from '../../../components/cardHooicardtakeout';

import {
  EXTERIOR_PREVIEW_VALUES,
  INTERIOR_PREVIEW_VALUES,
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_PROPERTIES,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  REQUEST_VEHICLE_TASKS,
} from '../../../constants';

import { Check, IsOpen } from '../../../../../components/Icon';
import {
  deleteVehicle,
  deleteVehicleProperty,
  downloadImages,
  fetchVehicle,
  fetchVehicleTasks,
  setVehicleProperty,
} from '../../../actions';
import { Loader } from '../../../../../components/Loader';
import { VehicleExtraCostCard } from '../../../components/CardExtraCost';
import { VehicleOutgoingInvoiceCard } from '../../../components/CardOutgoingInvoice';
import { VehicleTasksCard } from '../../../components/CardVehicleTasks';
import { VehicleWebsiteCard } from '../../../components/CardWebsite';
import { VehicleInvoicesCard } from '../../../components/VehcleInvoicesCard';
import { VehicleInspectionCardv2 } from '../../../components/VehicleInspectionCardv2';
import { EditVehicleOptions } from '../../../pages/create/OptionsStep/EditVehicleOptions';
// import { VehicleTasksRemarksCard } from '../../../components/CardVehicleTasksRemarks';

//import { VehicleHooiInstallationPhotoCard } from '../components/CardHooiInstallationPhotos';
import { Permission } from '../../../../../components/Permission';
import {
  GRANT_PERMISSIONS,
  INVOICES_PAGE,
  VEHICLE_ACTIONS_BUTTON,
  VEHICLE_DETAILS_BUTTON,
  VEHICLE_DOCUMENTS_CRUD,
  VEHICLE_DOWNLOAD_IMAGES,
  VEHICLE_EDIT,
  VEHICLE_EXTRA_COSTS_CRUD,
  VEHICLE_HEXON_BUTTON,
  VEHICLE_INSPECTION_CRUD,
  VEHICLE_INVOICES_BUTTON,
  VEHICLE_LOGS,
  VEHICLE_REMOVE,
  VEHICLE_TAKEN_BUTTON,
  VEHICLE_TRANSPORT_CRUD,
} from '../../../../../components/Permission/constants';
import { initialState as api } from '../../../../Api/reducer';

import { fetchVehicleInvoices } from '../../../../Invoices/actions';
import { VehicleClaimCard } from '../../../components/CardClaim';
import { VehicleHooiInstallationPhotoCard } from '../../../components/CardHooiInstallationPhotos';
import { VehicleRemarksCard } from '../../../components/CardVehicleRemarks';
import env from '../../../../../env';
import { VehicleOptionsCard } from '../../../components/VehicleOptionsCard';
import { PdfPreview } from '../../../components/PriceCardPDF/PdfPreview';
import { SaleAgreementPdfPreview } from '../../../components/SaleAgreement/SaleAgreementPdfPreview';
import LoadingDetailsPageCard from '../../../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import cn from 'classnames';
import styles from './detailsColumns.module.css';
import { AppClientId } from '../../../../Shared/constants';
import { KanbanRemarksCard } from '../../../components/KanbanRemarksCard';
import { VehicleOutgoingProductInvoiceCard } from '../../../components/CardProductOutgoingInvoice';
import {
  REQUEST_ADD_INVOICE_SUBJECT,
  REQUEST_REMOVE_INVOICE_SUBJECT,
  REQUEST_VEHICLE_INVOICES,
} from '../../../../Invoices/constants';
import { VehicleHooicardInslag } from '../../../components/cardHooicardinslag';
import { selectVehicleProperty } from '../../../selectors';
import LoadingField from '../../../../../containers/App/Components/LoadingField/LoadingField';
import { WS1_8_PreInspection } from '../../../../KanbanBoards/cells/WS/WS1_8_PreInspection';

import { VehicleProductTasksSection } from '../../../components/VehicleProductTasksSection';
import { HOOI_check_in } from '../../../../KanbanBoards/cells/HOOI/HOOI_check_in';
import { VehicleTransportCard } from './../../../components/CardTransport';
import { VehicleTasksRemarksCard } from '../../../components/CardVehicleTasksRemarks';

//comment1
const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  }
  .info-card {
    min-width: 260px;
    width: 100%;

    margin: 5px 0;
    // border: 1px solid #dbdcdc;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07); /* Grey box shadow */
  }
  .info-card.wide {
    width: 99%;
  }

  .info-card-fin {
    min-width: 260px;
    width: 100%;
    margin: 5px 0;
    // border: 1px solid #dbdcdc;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07); /* Grey box shadow */
  }
  .info-card-fin.wide {
    width: 99%;
  }

  .vehicle-info-card info-card {
    &.misc {
      .button {
        margin: 2px;
        background-color: #ddd;
        color: #333;
      }
    }
  }

  .vbox .toggleBtn {
    margin-left: auto;
    width: 12%;
  }

  .slider-block {
    background-color: #fff;
    width: 100%;
    min-width: 260px;
    width: 100%;
    margin: 10px 0;
    border: 0px solid #dbdcdc;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.07);
  }

  .vbox.col {
    width: auto;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  @media (max-width: 1440px) {
    gap: 5px;
    width: 100%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;

    & > div {
      width: 100%;
    }
  }
`;
const STATE = {
  previewType: 'interior',
  isShowExsterior: true,
  isShow: true,
  loading: false,
  IsOpen: false,
  showSaleAgreementPdfPreview: false,
  showLocationChange: false,
};

class VehicleDetailsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  renderActionModal() {
    return (
      <HOOI_check_in
        vehicleDetails
        cell={{ vehicle: this.props.vehicle }}
        action={{ label: 'label', id: this.getActionIdByName('HOOI_check_in') }}
        payload={{ task_name: 'task_spray' }}
        column={{ label: 'HOOI_check_in' }}
        loggedUserId={this.props.loggedInUser}
      />
    );
  }

  getActionIdByName(name) {
    return this.props.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  componentDidMount() {
    setTimeout(() => this.setState({ showOutgoingInvoiceCard: true }), 1500);
    setTimeout(() => this.setState({ loadSliderAfterTimeout: true }), 800);
    setTimeout(this.props.fetchVehicleTasks, 2000);
    this.setOutgoingProductInvoiceCardData();
  }

  get isFromKanban() {
    return this.props.location.state?.from?.includes('/boards');
  }

  setOutgoingProductInvoiceCardData() {
    this.props.fetchVehicleInvoices(result => {
      if (result?.items?.length > 0) {
        const outgoingProductInvoices = result.items.filter(invoice => {
          const isOutgoing = invoice?.direction === 'outgoing';
          const isProduct = invoice?.subjectType === 'product';
          const isNotFinal = !invoice?.isFinal;

          return isOutgoing && isProduct && isNotFinal;
        });

        let lastFinalProductInvoice = [];

        if (!outgoingProductInvoices?.length) {
          lastFinalProductInvoice = result.items.filter(invoice => {
            const isOutgoing = invoice?.direction === 'outgoing';
            const isProduct = invoice?.subjectType === 'product';
            const isFinal = invoice?.isFinal === true;

            return isOutgoing && isProduct && isFinal;
          });
        }

        console.log('Filtered outgoing product invoices:', lastFinalProductInvoice);

        if (outgoingProductInvoices.length > 0 || lastFinalProductInvoice?.length > 0) {
          const lastCreatedOutgoingProductId = outgoingProductInvoices[0]?.id ?? lastFinalProductInvoice[0]?.id;
          this.setState({ outgoingProductInvoiceId: lastCreatedOutgoingProductId });
        }
      }
    });
  }

  hideBlock(val) {
    this.setState({ loading: true });
    return this.setState(prev => ({ ...prev, previewType: 'exterior', isShow: val, loading: false }));
  }

  setShowLocationChange = () => {
    this.setState({ showLocationChange: true });
  };

  hideExteriorBlock(val) {
    this.setState({ loading: true });
    return this.setState(prev => ({ ...prev, isShowExsterior: val, loading: false }));
  }

  handleDelete = () => {
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (!confirm('delete vehicle?')) return;
    this.props.deleteVehicle(result => {
      if (result) {
        return this.to('/');
      }
    });
  };

  downloadImages() {
    this.setState({ downloadingImages: true }, () => {
      this.props.downloadImages(result => {
        this.setState({ downloadingImages: false });
        window.open(`/storage/zip/tmp/${this.props.vehicle.id}.zip`);
      });
    });
  }

  renderProductInvoiceCard() {
    if (this.props.workInvoices) return <Loader small />;

    return (
      <VehicleOutgoingProductInvoiceCard
        vehicleId={this.props.vehicle.id}
        vehicle={this.props.vehicle}
        invoiceId={this.state.outgoingProductInvoiceId}
      />
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const params = new URLSearchParams(window.location.search);
    const showLinktree = params.get('showLinkTree') === 'yes' || window.innerWidth <= 768;

    if (this.props.work || this.props.workInvoices) return <Loader small />;
    return (
      <Container className={styles.containerPage}>
        {this.state.showPdfPreview && (
          <PdfPreview onClose={() => this.setState({ showPdfPreview: false })} vehicle={vehicle} />
        )}
        {this.state.showSaleAgreementPdfPreview && (
          <SaleAgreementPdfPreview onClose={() => this.setState({ showSaleAgreementPdfPreview: false })} vehicle={vehicle} />
        )}
        <VBox left className={cn('col', styles.firstColumn)} top>
          <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.linktree.quick_links')}</h2>
            <Permission permission={VEHICLE_EDIT}>
              <div className={styles.containerButton}>
                {vehicle.location_address_id == '5' ? (
                  <div className={styles.containerButton}>
                    {this.lbl('vehicle.linktree.presentlocation')} {this.lbl('vehicle.linktree.steenwijk')}
                  </div>
                ) : vehicle.location_address_id == '390' ? (
                  <div className={styles.containerButton}>
                    {this.lbl('vehicle.linktree.presentlocation')} {this.lbl('vehicle.linktree.opslag')}
                  </div>
                ) : vehicle.location_address_id == '339' ? (
                  <div className={styles.containerButton}>
                    {this.lbl('vehicle.linktree.presentlocation')} {this.lbl('vehicle.linktree.staphorst')}
                  </div>
                ) : vehicle.location_address_id == '570' ? (
                  <div className={styles.containerButton}>
                    {this.lbl('vehicle.linktree.presentlocation')} {this.lbl('vehicle.linktree.abcamsterdam')}
                  </div>
                ) : vehicle.location_address_id == '571' ? (
                  <div className={styles.containerButton}>
                    {this.lbl('vehicle.linktree.presentlocation')} {this.lbl('vehicle.linktree.reservelocatie')}
                  </div>
                ) : (
                  'Niet aanwezig bij Hooikammer'
                )}
                <Button className={styles.button} onClick={this.setShowLocationChange}>
                  {this.lbl('vehicle.location.change')}
                </Button>
                {this.state.showLocationChange && (
                  <VehicleLocationCard
                    vehicle={this.props.vehicle}
                    showLocationChange={this.state.showLocationChange}
                    setShowLocationChange={value => this.setState({ showLocationChange: value })}
                  />
                )}
              </div>

              <div className={styles.containerButton}>
                <Button
                  className={cn(styles.button, { [styles.buttonEdit]: vehicle.action_ws2_interior_inspection_done == '1' })}
                  onClick={this.tofn(`/boards/1/action-page/${vehicle.id}`)}
                >
                  {this.lbl('vehicle.linktree.inspecteren')}
                </Button>
              </div>
              {this.renderActionModal()}

              <div className={styles.containerButton}>
                <Button
                  primary
                  className={cn(styles.button, { [styles.buttonEdit]: vehicle.HOOI_inslag_done_date })}
                  onClick={() => {
                    this.setState(prevState => ({ showInslagModal: !prevState.showInslagModal }));
                  }}
                >
                  {this.lbl('vehicle.location.inslag')}
                </Button>
              </div>
            </Permission>
          </Card>

          <VehicleInfoCard vehicle={this.props.vehicle} />
          {window.innerWidth > 768 && (
            <>
              <VehicleHooicardproducts vehicle={this.props.vehicle} />
              
              <VehicleDataCard vehicle={this.props.vehicle} />
              <VehicleDataConsumptionCard vehicle={this.props.vehicle} />
              {!env.hide_rdw_card ? <VehicleRDWandHistoryDataCard vehicle={this.props.vehicle} /> : null}

              <Permission permission={INVOICES_PAGE}>
                {this.state.showOutgoingInvoiceCard ? <VehicleOutgoingInvoiceCard vehicle={this.props.vehicle} /> : null}
              </Permission>
            </>
          )}
          {/* {window.innerWidth <= 768 && (
            <>
              <VehicleLabelCard vehicle={this.props.vehicle} />

              <VehicleLocationCard vehicle={this.props.vehicle} />
              <VehicleDataCard vehicle={this.props.vehicle} />
              <VehicleFinancePurchaseCard vehicle={this.props.vehicle} />
              <Permission permission={INVOICES_PAGE}>
                {this.state.showOutgoingInvoiceCard ? <VehicleOutgoingInvoiceCard vehicle={this.props.vehicle} /> : null}
              </Permission>
              <VehicleTasksCard vehicle={this.props.vehicle} />
              {/* <VehicleBpmCard vehicle={this.props.vehicle} />
              <Permission permission={VEHICLE_EXTRA_COSTS_CRUD}>
                <VehicleExtraCostCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
              </Permission>
             {this.props.workVehicle ? (
                <LoadingDetailsPageCard />
              ) : (
                <VehicleFinanceSalesCard vehicle={this.props.vehicle} />
              )}
              {env.clientId !== AppClientId.HOOIKAMMER && <VehicleWebsiteCard vehicle={this.props.vehicle} />}
              {!env.hide_counterscard ? <VehicleCardCounters vehicle={this.props.vehicle} /> : null}
            <VehicleClaimCard vehicle={this.props.vehicle} />
            </>
          )} */}
        </VBox>
        <VBox left className="col" top style={{ flex: '0 0 50%' }}>
          <Permission permission={INVOICES_PAGE}>
            {this.state.outgoingProductInvoiceId && window.innerWidth > 768 && this.renderProductInvoiceCard()}
          </Permission>
          <Wrapper>
            <VBox top>
              <VehicleFinancePurchaseCard vehicle={this.props.vehicle} />
              {!env.hide_bpm_card ? <VehicleBpmCard vehicle={this.props.vehicle} /> : null}
              {this.props.workTask ? (
                <LoadingDetailsPageCard />
              ) : (
                <VehicleTasksCard vehicle={this.props.vehicle} onAdded={this.setOutgoingProductInvoiceCardData.bind(this)} />
              )}

              {/* <VehicleTasksRemarksCard vehicle={this.props.vehicle} /> */}

              {this.props.workRemarks ? (
                <LoadingDetailsPageCard />
              ) : (
                <VehicleRemarksCard vehicle={this.props.vehicle} loggedUserId={this.props.loggedInUserId} />
              )}
              <VehicleTasksRemarksCard vehicle={this.props.vehicle} />
              {/* <KanbanRemarksCard
                vehicle={this.props.vehicle}
                remarksType={'hooiInslagRemarks'}
                additionalRemarksType={'hooiInslag_remarks'}
              /> */}
            </VBox>
            <VBox top>
              {this.props.workVehicle ? (
                <LoadingDetailsPageCard />
              ) : (
                <VehicleFinanceSalesCard vehicle={this.props.vehicle} />
              )}
              {!env.hide_counterscard ? <VehicleCardCounters vehicle={this.props.vehicle} /> : null}
              <VehicleLabelCard vehicle={this.props.vehicle} />
              {env.clientId !== AppClientId.HOOIKAMMER && <VehicleWebsiteCard vehicle={this.props.vehicle} />}
              <Permission permission={VEHICLE_TRANSPORT_CRUD}>
                {!env.hide_transport_card ? (
                  <VehicleTransportCard
                    key={`transport-${this.props.vehicle.id}-${this.props.vehicle.creditor_company}`}
                    vehicle={this.props.vehicle}
                  />
                ) : null}
              </Permission>

              <VehicleHooicardInslag
                vehicle={this.props.vehicle}
                vehicleId={this.props.vehicle?.id}
                loggedUserId={this.props.loggedInUserId}
                hooiInslagUserId={this.props.hooiInslagUserId}
                showModal={this.state.showInslagModal} // Modal state
                onCloseModal={() => this.setState({ showInslagModal: false })} // Close modal handler
                onResetParentState={() => this.setState({ showInslagModal: false })} // Reset parent state
              />

              <VehicleHooicardtakeout vehicle={this.props.vehicle} />

              {/* <VehicleHooicardtakeout vehicle={this.props.vehicle} /> */}
            </VBox>
          </Wrapper>

          <>
            <VehicleHooiInstallationPhotoCard vehicle={this.props.vehicle} />
            <Permission permission={VEHICLE_INSPECTION_CRUD}>
              <VehicleInspectionCardv2 vehicle={this.props.vehicle} isFromKanban={this.isFromKanban} />
            </Permission>

            <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
              <EditVehicleOptions photoBlock vehicle={this.props.vehicle} />
            </Card>
            <VehicleOptionsCard vehicle={this.props.vehicle} />
          </>

          {this.state.loadSliderAfterTimeout ? (
            <>
              {(this.state.isShow || this.state.isShowExsterior) && window.innerWidth > 768 && !env.hide_photos_card && (
                <VBox className="slider-block" center>
                  <Button
                    className="toggleBtn"
                    onClick={() =>
                      this.state.previewType === 'exterior'
                        ? this.setState({ previewType: 'interior' })
                        : this.setState({ previewType: 'exterior' })
                    }
                  >
                    {this.state.previewType === 'exterior' ? 'Interior' : 'Exterior'}
                  </Button>
                  {this.state.previewType === 'exterior' && this.state.isShowExsterior && (
                    <Slider
                      hideExteriorBlock={this.hideExteriorBlock.bind(this)}
                      vehicleId={this.vehicle.id}
                      type={this.state.previewType}
                      helga_id={this.vehicle.helga_id}
                      spinValues={EXTERIOR_PREVIEW_VALUES}
                    />
                  )}
                  {this.state.previewType === 'interior' && this.state.isShow && (
                    <Slider
                      hideBlock={this.hideBlock.bind(this)}
                      vehicleId={this.vehicle.id}
                      type={this.state.previewType}
                      helga_id={this.vehicle.helga_id}
                      spinValues={INTERIOR_PREVIEW_VALUES}
                    />
                  )}
                </VBox>
              )}
            </>
          ) : null}

          <>
            {window.innerWidth >= 768 && (
              <Permission permission={INVOICES_PAGE}>
                <VehicleInvoicesCard vehicle={this.props.vehicle} />
              </Permission>
            )}
          </>
        </VBox>

        <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
          <Permission permission={VEHICLE_DOCUMENTS_CRUD}>
            <VehicleDocumentsCard vehicle={this.props.vehicle} />
          </Permission>

          <VehicleLocationCard vehicle_details vehicle={this.props.vehicle} />
          <Card className={cn('vehicle-info-card info-card misc', styles.card)}>
            <h2 className="card-title mb-2 text-muted">Overige functies</h2>
            <div className={styles.containerButton}>
              <Permission permission={VEHICLE_EDIT}>
                <Button className={styles.buttonEdit} primary onClick={this.tofn(`/vehicles/${this.vehicle.id}/edit`)}>
                  {this.lbl('edit')}
                </Button>
              </Permission>
              {!env.hide_other_buttons && (
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}`)}>
                  {this.lbl('vehicle.details.columns.title')}
                </Button>
              )}
{/*
              <a
                className="button text-center text-decoration-none text-white"
                href={`${api.rootUrl}pdf/${this.vehicle.id}?template=schaderapport`}
                target="_blank"
              >
                Inspectie rapport
              </a> */}

              <a
                className="button text-center text-decoration-none text-white"
                href={`${api.rootUrl}pdf/${this.vehicle.id}?template=inspectierapport&installation=hooikammer`}
                target="_blank"
              >
                Inspectie rapport
              </a>

         
       
              <Permission permission={VEHICLE_DETAILS_BUTTON}>
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/legacy`)}>
                  {this.lbl('vehicle.details.title')}
                </Button>
              </Permission>
              {!env.hide_other_buttons && (
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/options`)}>
                  {this.lbl('vehicle.details.options.title')}
                </Button>
              )}
              {!env.hide_other_buttons && (
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/documents`)}>
                  {this.lbl('vehicle.details.documents.title')}
                </Button>
              )}
              {!env.hide_other_buttons && (
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/price`)}>
                  {this.lbl('vehicle.details.price.title')}
                </Button>
              )}
              {!env.hide_other_buttons && (
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/supplier`)}>
                  {this.lbl('vehicle.details.supplier.title')}
                </Button>
              )}
              <Permission permission={VEHICLE_INVOICES_BUTTON}>
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/invoices`)}>
                  {this.lbl('vehicle.details.invoices.title')}
                </Button>
              </Permission>
              <Permission permission={VEHICLE_ACTIONS_BUTTON}>
                {!env.hide_other_buttons && (
                  <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/actions`)}>
                    actions
                  </Button>
                )}
              </Permission>
              <Permission permission={VEHICLE_TAKEN_BUTTON}>
                {!env.hide_other_buttons && (
                  <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/state`)}>
                    Taken
                  </Button>
                )}
              </Permission>
              {/* <Permission permission={VEHICLE_HEXON_BUTTON}>
              <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/hexon`)}>Hexon</Button>
            </Permission> */}
              <Permission permission={GRANT_PERMISSIONS}>
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/carcollect`)}>
                  Carcollect
                </Button>
              </Permission>
              <Permission permission={VEHICLE_DOWNLOAD_IMAGES}>
                {!env.hide_other_buttons && (
                  <Button
                    className={styles.button}
                    disabled={this.state.downloadingImages}
                    onClick={this.downloadImages.bind(this)}
                  >
                    {this.state.downloadingImages ? <Loader small /> : null} {this.lbl('vehicle.download-images')}
                  </Button>
                )}
              </Permission>
              <Permission permission={VEHICLE_LOGS}>
                <Button className={styles.button} onClick={this.tofn(`/vehicles/${this.vehicle.id}/history`)}>
                  Logs
                </Button>
              </Permission>
              {env.enable_hemex ? <Button onClick={this.tofn(`/vehicles/${this.vehicle.id}/hemex`)}>Hemex</Button> : null}

              {env.vehicle_details_show_special_button ? (
                <Button
                  className={styles.button}
                  active={this.vehicle.special_customer}
                  onClick={() => {
                    this.props.setVehicleProperty('special_customer', this.vehicle.special_customer == '1' ? null : '1');
                  }}
                >
                  {this.vehicle.special_customer ? <Check /> : null}&nbsp;Special customer
                </Button>
              ) : null}

              <Permission permission={VEHICLE_REMOVE}>
                <Button className={styles.buttonDelete} warning onClick={this.handleDelete}>
                  Delete
                </Button>
              </Permission>
            </div>
          </Card>
        </VBox>
      </Container>
    );
  }
}

VehicleDetailsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    //  work: selectWorks([REQUEST_VEHICLE_INVOICES]),
    workVehicle: selectWork(REQUEST_VEHICLE),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-remarks`),
    workTask: selectWork(REQUEST_VEHICLE_TASKS),
    workInslag: selectWorks([`${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`, REQUEST_VEHICLE_PROPERTY_UPDATE]),
    loggedInUserId: selectUserId(),
    workInvoices: selectWorks([REQUEST_VEHICLE_INVOICES, REQUEST_ADD_INVOICE_SUBJECT, REQUEST_REMOVE_INVOICE_SUBJECT]),
    hooiInslagUserId: selectVehicleProperty(ownProps.vehicle?.id, 'HOOI_inslag_done_user_id'),
    //creditorCompany: selectCompany(getPropByName(ownProps.vehicle, 'creditor_company')),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setVehicleProperty(name, value, callback) {
      if (value === null || value === undefined) {
        dispatch(deleteVehicleProperty(ownProps.vehicle.id, name));
      } else {
        dispatch(setVehicleProperty(ownProps.vehicle.id, name, value));
      }
    },
    deleteVehicle(callback) {
      dispatch(deleteVehicle(ownProps.vehicle.id, callback));
    },
    downloadImages(callback) {
      dispatch(downloadImages(ownProps.vehicle.id, callback));
    },
    fetchVehicleInvoices(callback) {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id, '', 0, callback));
    },
    fetchVehicleTasks(callback) {
      dispatch(fetchVehicleTasks(ownProps.vehicle?.id, callback));
    },
    setValueLocationAddress(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_address_id', val));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'location_company_id', '4'));
      // window.location.reload();
    },
    setValueTransportOutgoing() {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_initiated', '0'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_done', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_assigned_to', null));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'transport_outgoing_completed_date', 'date_today'));
      // window.location.reload();
    },
    setValuePopnagels() {
      let extra_cost_popnagels_sum = Number(ownProps.vehicle?.extra_cost_popnagels) + 15;
      let extra_cost_sum = Number(ownProps.vehicle?.extra_cost_sum) + 15;
      let extra_cost_economic_prize_sum = Number(ownProps.vehicle?.economic_prize) + 15;

      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_popnagels', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'extra_cost_popnagels', extra_cost_popnagels_sum));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'extra_cost_sum', extra_cost_sum));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'economic_prize', extra_cost_economic_prize_sum));
    },
    setValueTestDriveAllClear(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_engine_general', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_ac', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_brakes', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_transmission', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_electrics', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'state_drive', '1'));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_test_drive', '0'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDetailsColumns = compose(withConnect, withRouter)(VehicleDetailsColumnsComp);
